import { render, staticRenderFns } from "./StaffScheduleManager.vue?vue&type=template&id=60622b0b"
import script from "./StaffScheduleManager.vue?vue&type=script&lang=js"
export * from "./StaffScheduleManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports